import React, { useState, useEffect, useRef } from 'react'

import Grid from '@material-ui/core/Grid';
import ImputComponent from "../../InputComponent"
import { LanguageFactory, LocalPersistence } from '../../../factories';
import { useLanguage } from '../../../store/languageContext'
import SearchDebounceBar from '../../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';
import { PropertySearch } from '../../../factories/propertySearchs';
import { Button, Card, message, Table } from 'antd';
import { getAffiliations } from '../../../services/affiliations';
import EditAward from './Edit';
import PageContainer from '../../CSIComponents/PageContainer';
import AddAward from './Add';
import Loading from '../../Loading';
import { sortHelper } from '../../../helpers/misc/sortHelper'


const LoyailyPrograms = (props: any) => {
    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const initialRender = useRef(true);
    const [searchs, setSearch] = useState<string[]>([]);
    const [dataSource, setDataSource] = useState([]);
    const [addFlag, setAddFlag] = useState(false);
    const [editFlag, setEditFlag] = useState(false);
    const [total, setTotal] = useState(dataSource.length)
    const [data, setData] = useState(dataSource);
    const [rowData, setRowData] = useState([]);
    const [addLoading, setAddLoading] = useState(false)
    const columns = [
        {
            title: '',
            key: 'index',
            render: (text: string, record: [], index: number) => index += 1,
            width: '40px'
        },
        {
            title: 'Program Name',
            dataIndex: 'programname',
            key: 'programname',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a:[], b:[]) => sortHelper(a, b, 'programname'),
            showSorterTooltip: false,
        },
        {
            title: 'Travel Sector',
            dataIndex: 'travelsector',
            key: 'travelsector',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a:[], b:[]) => sortHelper(a, b, 'travelsector'),
            showSorterTooltip: false,
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a:[], b:[]) => sortHelper(a, b, 'description'),
            showSorterTooltip: false,
        },
    ]

    const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()
    const recentlySearchs = () => {
        return searchs.map((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }

    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }

    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }

    const getData = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        setAddLoading(true)
        getAffiliations(session.supplier, session.propertyId).then(res => {
            setAddLoading(false)
            if (res.result.success) {
                const resData = res?.property?.affiliations?.loyaltyprograms?.length > 0 ? res.property.affiliations.loyaltyprograms : [];
                resData.forEach((item: any, index: number) => { item.key = '' + index; })
                setDataSource(resData);
                setData(resData)
            } else {
                message.error({
                    content: res?.error[0]?.message || 'operation failed'
                });
            }
        }, err => {
            message.error({
                content: err.message || err.error[0].message
            });
            setAddLoading(false)
        });
    }
    useEffect(() => {
        getData()
    }, [])
    const filterData = async (query: string) => {
        const filterData = data.filter((item: any) => {
            const itemData: any = {}
            columns.forEach((col: any) => {
                itemData[col['dataIndex']] = (item[col.dataIndex] && item[col.dataIndex].toString().toLowerCase()) || '';
            })
            return JSON.stringify(Object.values(item))
            .toLocaleLowerCase()
            .indexOf(query.toLocaleLowerCase()) > -1;

        })

        setDataSource(filterData);
    }
    const cancelAddAndEdit = () => {
        getData()
        setAddFlag(false);
        setEditFlag(false);
        props.disableTabPanes(false)
        props.cancelEditable();
    }
    useEffect(() => {
        setTotal(dataSource.length)
    }, [dataSource])
    // search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [searchTermDebounced])
    return (addLoading ? <Loading type="large" /> : <>
        {!addFlag && !editFlag && <PageContainer>
            <Card style={{ marginTop: -15 }}>
                <Grid container spacing={0} className="containerSpacing py-0">
                    <Grid item xs={12} className="p-0">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>Loyalty Programs</div>
                            <div><Button type="primary" className="db-add-btn" onClick={() => { setAddFlag(true); setEditFlag(false); props.isEditable(); props.disableTabPanes(true) }}>Add</Button></div>
                        </div>
                    </Grid>
                    <Grid item xs={4} className="pb-0 px-0 my-0">
                        <ImputComponent
                            className='SearchBar'
                            label='Search'
                            labelShrink={true}
                            value={searchTerm}
                            onChange={onChangeSearch}
                            placeholder='Search Loyalty Programs'
                            endAdornment={<SearchIcon style={{ color: '#9a9a9a' }} />}
                        />
                        <div className="recentlySearchs">
                            <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} className="p-0">
                        <Table
                            columns={columns}
                            dataSource={
                                dataSource
                            }
                            pagination={{
                                size: "small",
                                total,
                                showSizeChanger: true,
                                showTotal: (total, range) => `Total ${total} items, Current ${range[0]}-${range[1]}`,
                                defaultPageSize: 10,
                                defaultCurrent: 1,
                                onChange: (page, pageSize) => {
                                    console.log(page + '===' + pageSize)
                                }
                            }}
                            onRow={record => {
                                return {
                                    onClick: event => {
                                        setAddFlag(false);
                                        setEditFlag(true);
                                        setRowData(record);
                                        // props.isEditable();
                                        //props.disableTabPanes(true)
                                    },
                                };
                            }}
                        />
                    </Grid>
                </Grid>
            </Card>
        </PageContainer>}
        {addFlag && <AddAward cancelAddAndEdit={cancelAddAndEdit} />}
        {editFlag && <EditAward isEditable={props.isEditable} cancelEditable={props.cancelEditable} disableTabPanes={props.disableTabPanes} cancelAddAndEdit={cancelAddAndEdit} rowData={rowData} />}
    </>

    )
}

export default LoyailyPrograms;
